"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSpinnerKind = exports.getRightIcon = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _ArrowForward = _interopRequireDefault(require("@quintoandar/cozy-icons/ArrowForward"));
var _ChevronDown = _interopRequireDefault(require("@quintoandar/cozy-icons/ChevronDown"));
var _Launch = _interopRequireDefault(require("@quintoandar/cozy-icons/Launch"));
var _Spinner = require("../../Spinner/Spinner.types");
var _messages = _interopRequireDefault(require("../messages"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
var getRightIcon = exports.getRightIcon = function getRightIcon(_ref) {
  var showArrowForward = _ref.showArrowForward,
    showChevronDown = _ref.showChevronDown,
    showExternalIcon = _ref.showExternalIcon;
  var intl = (0, _reactIntl.useIntl)();
  if (showArrowForward) return /*#__PURE__*/_react["default"].createElement(_ArrowForward["default"], {
    alt: intl.formatMessage(_messages["default"].arrowForward),
    size: "small"
  });
  if (showChevronDown) return /*#__PURE__*/_react["default"].createElement(_ChevronDown["default"], {
    alt: intl.formatMessage(_messages["default"].chevronDown),
    size: "small"
  });
  if (showExternalIcon) return /*#__PURE__*/_react["default"].createElement(_Launch["default"], {
    alt: intl.formatMessage(_messages["default"].Launch),
    size: "small"
  });
  return false;
};
var getSpinnerKind = exports.getSpinnerKind = function getSpinnerKind(variant, inverse) {
  var pureVariantToInverseList = ['destructive', 'primary'];
  var inverseVariantToInverseList = ['assistive', 'subtle', 'destructiveAssistive', 'destructiveSubtle'];
  var pureVariantToDefaultList = ['assistive'];
  var inverseVariantToDefaultList = ['primary'];
  var pureVariantToCriticalList = ['destructiveAssistive', 'destructiveSubtle'];
  if (!inverse && pureVariantToInverseList.includes(variant) || inverse && inverseVariantToInverseList.includes(variant)) {
    return _Spinner.Kind.INVERSE;
  }
  if (!inverse && pureVariantToDefaultList.includes(variant) || inverse && inverseVariantToDefaultList.includes(variant)) {
    return _Spinner.Kind.DEFAULT;
  }
  if (!inverse && pureVariantToCriticalList.includes(variant)) {
    return _Spinner.Kind.CRITICAL;
  }
  return _Spinner.Kind.DEFAULT;
};